import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { DISCOUNT_ORDINARY_NEW_ITEM_FOR_ORDINARY_QUERY } from "./schema";

export const useDiscountOrdinaryNewItemForOrdinaryQuery = (hotelID: string, duplicateDiscountId?: string) => {
	const { data } = useCustomSuspenseQuery(DISCOUNT_ORDINARY_NEW_ITEM_FOR_ORDINARY_QUERY, {
		variables: { hotelID, duplicateDiscountId },
		fetchPolicy: "no-cache",
	});

	return {
		discountOrdinaryNewItemForOrdinaryServerModel: data,
	};
};
